<template>
  <v-list color="transparent" dense>
    <v-list-item :ripple="false" inactive>
      <v-list-item-icon>
        <Icon name="checkmark-system" outline class="turquoise--text" />
      </v-list-item-icon>

      <v-list-item-content class="pt-1 pb-4 lapis--text text--lighten-2">
        {{ $t('fields.checkout.sidebar.benefit_ready_to_use') }}
      </v-list-item-content>
    </v-list-item>

    <v-list-item :ripple="false" inactive>
      <v-list-item-icon>
        <Icon name="checkmark-system" outline class="turquoise--text" />
      </v-list-item-icon>

      <v-list-item-content class="pt-1 pb-4 lapis--text text--lighten-2">
        {{ $t('fields.checkout.sidebar.benefit_invoice_email') }}
      </v-list-item-content>
    </v-list-item>

    <v-list-item :ripple="false" inactive>
      <v-list-item-icon>
        <Icon name="checkmark-system" outline class="turquoise--text" />
      </v-list-item-icon>

      <v-list-item-content class="pt-1 pb-4 lapis--text text--lighten-2">
        {{ $t('fields.checkout.sidebar.benefit_upgrade') }}
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>
<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import Icon from '@/components/Icons/Icon.vue';

@Component({
  components: {
    Icon,
  },
})
export default class CheckoutBenefitsList extends Vue {}
</script>
